module.exports = __webpack_public_path__ + "img/img-10-desk.504a62f4.jpg";